export default __webpack_public_path__ + "static/placeholder-8181bbbdee1c29dd59cbc65a52935c5d.png";